import { defineComponent as _defineComponent } from 'vue'
import Header from "@/components/sgre/Header.vue";
import Footer from "@/components/sgre/Footer.vue";
import { useRouter } from "vue-router";
import { store } from "@/store/store";
import { ref, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const router = useRouter();

const notExistGradeData = ref(false);

const vinNo = ref("");
const typeName = ref("");
const saleModel = ref("");
const grade = ref("");
const engine = ref("");
const turbo = ref("");
const driveSys = ref("");
const transmission = ref("");
const EDB = ref("");
const airbag = ref("");
const onsaleDate = ref("");

onMounted(function () {
  clearGradeInfo();
  notExistGradeData.value = false;
  vinNo.value = store.getters.vinNo;
  typeName.value = store.getters.typeName;
  saleModel.value = store.getters.saleModel;
  grade.value = store.getters.grade;
  engine.value = store.getters.engine;
  turbo.value = store.getters.turbo;
  driveSys.value = store.getters.driveSys;
  transmission.value = store.getters.transmission;
  EDB.value = store.getters.EDB;
  airbag.value = store.getters.airbag;
  onsaleDate.value = store.getters.onsaleDate;

  if (typeName.value.length === 1) {
    notExistGradeData.value = true;
  }
});

const toSearchGrade = () => {
  router.push("/SearchGrade");
};

const clearGradeInfo = () => {
  vinNo.value = "";
  typeName.value = "";
  saleModel.value = "";
  grade.value = "";
  engine.value = "";
  turbo.value = "";
  driveSys.value = "";
  transmission.value = "";
  EDB.value = "";
  airbag.value = "";
  onsaleDate.value = "";
};

const openPDF = () => {
  window.open("contact_paper.pdf");
};

const __returned__ = { router, notExistGradeData, vinNo, typeName, saleModel, grade, engine, turbo, driveSys, transmission, EDB, airbag, onsaleDate, toSearchGrade, clearGradeInfo, openPDF, Header, Footer }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})